import React from 'react';

const Paragraph = ({
  children, onClick, onMouseLeave, ...property
}) => (
  <p {...property} onClick={onClick} className={`${property.className}`} onMouseLeave={onMouseLeave} >{children}</p>
);

export default Paragraph;
